// Near the top of the file, add the API base URL
const API_BASE_URL = 'https://wonderent.wonderchef.com';

document.addEventListener('DOMContentLoaded', function() {
    // Add CSS dynamically
    const styles = `
        .page-width {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .rental-buyback-container {
            padding: 2rem 0;
        }

        .product-buyback-card {
            background: white;
            border-radius: 12px;
            padding: 2rem;
            max-width: 600px;
            margin: 2rem auto;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .product-details {
            display: flex;
            align-items: center;
            gap: 1.5rem;
            margin-bottom: 2rem;
        }

        .product-image {
            width: 120px;
            height: auto;
        }

        .product-title {
            font-size: 1.2rem;
            margin: 0;
        }

        .buyback-info {
            text-align: center;
            margin: 2rem 0;
        }

        .price {
            font-size: 2.5rem;
            color: #E31837;
            font-weight: bold;
            margin: 1rem 0;
        }

        .price-note {
            color: #666;
            font-size: 0.9rem;
        }

        .warranty-info {
            display: flex;
            align-items: center;
            gap: 1rem;
            background: #f8f8f8;
            padding: 1rem;
            border-radius: 8px;
            margin: 2rem 0;
        }

        .warranty-icon {
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .complete-purchase-btn {
            background: #E31837;
            color: white;
            width: 100%;
            padding: 1rem;
            border: none;
            border-radius: 8px;
            font-size: 1.1rem;
            cursor: pointer;
            transition: background-color 0.3s;
        }

        .complete-purchase-btn:hover {
            background: #c41530;
        }

        .complete-purchase-btn:disabled {
            background: #999;
            cursor: not-allowed;
        }

        @media (max-width: 768px) {
            .product-details {
                flex-direction: column;
                text-align: center;
            }

            .product-image {
                width: 200px;
            }
        }
    `;

    // Add styles to head
    const styleSheet = document.createElement("style");
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const rentalId = urlParams.get('rental_id');
    const originalOrderId = urlParams.get('original_order_id');
    const email = urlParams.get('email');

    if (!rentalId || !originalOrderId || !email) {
    //    console.error('Missing required parameters:', { rentalId, originalOrderId, email });
        return;
    }

    // Debug log
  //  console.log('Fetching buyback details for rental:', rentalId);
  //    console.log('Original Order ID:', originalOrderId);

    fetchOrderDetails(rentalId, email);

    async function fetchOrderDetails(rentalId, email) {
        try {
            const response = await fetch(
                `${API_BASE_URL}/api/rentals/customer/public/buyback/${rentalId}/?email=${encodeURIComponent(email)}`
            );
            
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Failed to load product details');
            }

            const data = await response.json();
            renderBuybackPage(data);
            
        } catch (error) {
        //    console.error('Error:', error);
            const container = document.querySelector('.rental-buyback-container');
            if (container) {
                container.innerHTML = `
                    <div class="product-buyback-card">
                        <h1>Error</h1>
                        <p>${error.message || 'Unable to load buyback details. Please try again.'}</p>
                        <a href="/account" class="submit-button">Return to Dashboard</a>
                    </div>
                `;
            }
        }
    }

    function renderBuybackPage(data) {
        const container = document.querySelector('.rental-buyback-container');
        
        container.innerHTML = `
            <div class="product-buyback-card">
                <div class="buyback-header">
                    <h1>Purchase Product</h1>
                </div>

                <div class="product-details">
                    <img src="${data.product_image || '/path/to/default-image.jpg'}" 
                         alt="${data.product_name}" 
                         class="product-image">
                    <h2 class="product-title">${data.product_name}</h2>
                </div>

                <p class="price-info">Purchase your rented product at the discounted price of</p>
                <div class="price">₹${data.buyback_amount}</div>
                <p class="price-note">This price is derived after adjusting the rental and security deposit amounts already paid by you.</p>

                <div class="warranty-info">
                    <img src="/cdn/shop/t/603/assets/warranty-icon.png" alt="Warranty" class="warranty-icon">
                    <p class="warranty-text">This product will remain under warranty for 1 year from the day your contracts ends.</p>
                </div>

                <button 
                    class="complete-purchase-btn"
                    data-rental-id="${data.rental_id}"
                    data-email="${email}"
                >
                    Complete Purchase
                </button>
            </div>
        `;

        // Add click handler for the purchase button
        const purchaseBtn = container.querySelector('.complete-purchase-btn');
        purchaseBtn.addEventListener('click', () => {
            handleBuyback(data.rental_id, email);
        });
    }

    // Handle buyback initiation
    async function handleBuyback(rentalId, email) {
        try {
            const button = document.querySelector('.complete-purchase-btn');
            const originalText = button.textContent;
            button.textContent = 'Processing...';
            button.disabled = true;

        //    console.log('Initiating buyback with:', { rentalId, email });
            
            const response = await fetch(`${API_BASE_URL}/api/rentals/customer/public/buyback/${rentalId}/?email=${encodeURIComponent(email)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            const data = await response.json();
        //    console.log('Buyback response:', data);
            
            if (response.ok) {
                const options = {
                    key: data.razorpay_key_id,
                    amount: data.amount,
                    currency: data.currency,
                    name: 'Product Buyback',
                    description: 'Complete your purchase',
                    order_id: data.razorpay_order_id,
                    handler: function(response) {
                        handlePaymentSuccess(response, rentalId);
                    },
                    prefill: {
                        email: email
                    },
                    theme: {
                        color: '#E31837'
                    }
                };
                
                const rzp = new Razorpay(options);
                rzp.open();
                
            } else {
        //        alert(data.error || 'Failed to initiate buyback');
            }
            
        } catch (error) {
        //    console.error('Error:', error);
        //    alert('Failed to process buyback request');
        } finally {
            const button = document.querySelector('.complete-purchase-btn');
            button.textContent = 'Complete Purchase';
            button.disabled = false;
        }
    }
    
    async function handlePaymentSuccess(response, rentalId) {
        try {
            const verifyResponse = await fetch(`${API_BASE_URL}/api/rentals/customer/public/buyback/${rentalId}/verify/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_signature: response.razorpay_signature
                })
            });
            
            const data = await verifyResponse.json();
        //    console.log('Verify response:', data);
            if (verifyResponse.ok) {
                // Redirect to the original order page
                window.location.href = `/pages/rental-order?order_id=${originalOrderId}&email=${encodeURIComponent(email)}`;
            } else {
                alert(data.error || 'Payment verification failed');
            }
            
        } catch (error) {
        //    console.error('Error:', error);
            alert('Failed to verify payment');
        }
    }
});